import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import paymentsAPI from '../../../services/api/payments';
import { PaymentsAccountInfo } from '../../../shared/ts/payments';
import { StyledTitle, StyledWrapper } from './UserPayments.styles';
import UserPaymentsAccountStatus from './UserPaymentsAccountStatus';
import UserPaymentsBankAccounts from './UserPaymentsBankAccounts';
import UserPaymentsTOS from './UserPaymentsTOS';

const UserPayments = (): JSX.Element => {
  const { t } = useTranslation(['payments']);

  const [accountInfo, setAccountInfo] = useState<PaymentsAccountInfo>();

  const getAccountInfo = async () => {
    try {
      const response = await paymentsAPI.getAccountInfo();
      setAccountInfo(response);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAccountInfo();
  }, []);

  const arePayoutsEnabled = accountInfo?.arePayoutsEnabled ?? false;
  const areChargesEnabled = accountInfo?.areChargesEnabled ?? false;
  const areTOSAccepted = accountInfo?.areTOSAccepted ?? false;

  return (
    <StyledWrapper>
      <StyledTitle>{t('payments:paymentInformation')}</StyledTitle>
      <UserPaymentsAccountStatus
        arePayoutsEnabled={arePayoutsEnabled}
        areChargesEnabled={areChargesEnabled}
      />
      <UserPaymentsBankAccounts />
      <UserPaymentsTOS
        areTOSAccepted={areTOSAccepted}
        setAccountInfo={setAccountInfo}
      />
    </StyledWrapper>
  );
};

export default UserPayments;
